import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var newsSection = {
  name: "55gfil",
  styles: "margin:16px auto;"
};
export var heading = /*#__PURE__*/css("margin-bottom:8px;color:", colors.neutral.heavy.default, ";", designTokenFonts.heading);
export var subtitle = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", designTokenFonts.body);
export var cards = {
  name: "1q7njkh",
  styles: "margin-top:10px;"
};